// Staff Vuex

import state from './salesmanStates.js'
import * as getters from './salesmanGetters.js'
import * as mutations from './salesmanMutations.js'
import * as actions from './salesmanActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
